/**
 * Shared filter logic — determines whether a node passes the current filter state.
 * Extracted from AdjacencyMap.tsx for reuse across all views.
 */

import type { AdjacencyNode, NodeFilters } from '../types/adjacency';

export function nodePassesFilter(node: AdjacencyNode, filters: NodeFilters): boolean {
  // Hard filter: pending-review nodes are hidden from all views (Task 6.10)
  if (node.spSyncReviewStatus != null) return false;
  if (filters.initiatives.length > 0 && !filters.initiatives.includes(node.strategicInitiative))
    return false;
  if (filters.statuses.length > 0 && (!node.status || !filters.statuses.includes(node.status)))
    return false;
  if (filters.phases.length > 0 && (!node.phase || !filters.phases.includes(node.phase)))
    return false;
  if (filters.axes.length > 0 && !filters.axes.includes(node.adjacencyAxis))
    return false;
  if (node.relatednessRing < filters.ringRange[0] || node.relatednessRing > filters.ringRange[1])
    return false;
  if (filters.sources.length > 0 && !filters.sources.includes(node.source))
    return false;
  if (filters.searchText) {
    const q = filters.searchText.toLowerCase();
    if (!node.name.toLowerCase().includes(q) && !node.description.toLowerCase().includes(q))
      return false;
  }
  return true;
}
